import axios from 'axios';

export default {
  getBillingPlans () {
    const url = `${process.env.VUE_APP_RAISON_API_URL}billing-plans`;
    return axios.get(url);
  },

  saveBillingPlan (billingPlan) {
    if(!billingPlan.id) {
      return this.createBillingPlan(billingPlan);
    }
    return this.updateBillingPlan(billingPlan);
  },

  createBillingPlan (billingPlan) {
    return axios.post(`${process.env.VUE_APP_RAISON_API_URL}billing-plans`, billingPlan);
  },

  getBillingPlan (billingPlanId) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}billing-plans/${billingPlanId}`);
  },

  updateBillingPlan (billingPlan) {
    return axios.put(`${process.env.VUE_APP_RAISON_API_URL}billing-plans/${billingPlan.id}`, billingPlan);
  },

  deleteBillingPlan (billingPlanId) {
    return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}billing-plans/${billingPlanId}`, billingPlanId);
  }
};